<template>
    <v-card flat outlined>
        <v-card-text>
            <div class="body-2 font-weight-medium mt-3 px-2 grey--text text--darken-1">
                {{course.categoryTitle}} / {{course.title}}
            </div>
            <div class="display-1 font-weight-medium px-2" :style="{color:course.color}">
                {{course.videos[actual].title}}
            </div>
            
            <div class="video-responsive mt-2">
                <iframe :src="'https://player.vimeo.com/video/'+course.videos[actual].id" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            </div>

            <v-row>
                <v-col cols="12" sm="4" md="3" v-for="(item, index) in course.videos" :key="item.id">
                    <v-card height="140px" hover :color="backColor(index)" @click="actual=index">
                        <v-card-text>
                            <div class="title font-weight-light" style="line-height:1.2" :class="textColor(index)">{{index+1}}. {{item.title}}</div>
                            <div class="mt-4 caption white--text d-flex align-center" style="line-height:1.2" v-if="actual==index">
                                <v-icon size="12px" color="white" class="mr-2">fa-video</v-icon>
                                <div>Playing...</div> 
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>

export default {
    data: () => ({
        loaded: false,
        info: {},
        actual: 0
    }),
    props: ['course'],
    methods: {
        backColor(index) {
            if (this.actual == index) {
                return this.course.color;
            } else {
                return 'grey lighten-4';
            }
        },
        textColor(index) {
            if (this.actual == index) {
                return 'white--text';
            } else {
                return 'grey--text text--darken-4';
            }
        }
    }
}
</script>

<style scoped>
	.video-responsive {
		position: relative;
		padding-bottom: 56.25%; /* 16/9 ratio */
		padding-top: 30px; /* IE6 workaround*/
		height: 0;
		overflow: hidden;
	}
	.video-responsive iframe,
	.video-responsive object,
	.video-responsive embed {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
</style>